export function isInstanceOf(instance, constructor) {
  return !!constructor && instance instanceof constructor;
}